// src/components/home/HeroBanner.jsx
import React from "react";

const getValidImages = (images) =>
  Array.isArray(images) ? images.filter((image) => image?.url) : [];

const HeroBanner = ({ banner, mobileImages = [] }) => {
  if (!banner) {
    return (
      <div className="w-full aspect-[4/3] md:aspect-[21/9] min-h-48 bg-gray-300 animate-pulse flex items-center justify-center">
        <span className="text-gray-500">Loading banner...</span>
      </div>
    );
  }

  const {
    title,
    img,
  } = banner;

  const imageUrl = img?.url ? `${img.url}` : null;
  const titleLines = String(title || "").split("\\n");
  const marqueeImages = getValidImages(mobileImages);
  const hasMobileMarquee = marqueeImages.length > 0;

  const renderMarqueeImage = (image, index, keyPrefix) => {
    const altText =
      image.alternativeText || titleLines.join(" ") || `Homepage banner ${index + 1}`;

    return (
      <div
        key={`${keyPrefix}-${image.id ?? index}`}
        className="hero-banner-marquee__item h-full shrink-0 w-[70vw]"
      >
        <img
          src={image.url}
          alt={altText}
          className="h-full w-full object-cover"
          draggable={false}
        />
      </div>
    );
  };

  const renderFallbackBackground = () => (
    <div
      className="block w-full aspect-[4/3] md:aspect-[21/9] min-h-48"
      style={{
        background: "linear-gradient(135deg, #0076be 0%, #48bf91 100%)",
      }}
    />
  );

  return (
    <section className="relative w-full">
      {/* Mobile: marquee from CAS-homepage imgs */}
      {hasMobileMarquee ? (
        <div className="relative w-full aspect-[4/3] overflow-hidden md:hidden">
          <div className="hero-banner-marquee absolute inset-0 overflow-hidden">
            <div className="hero-banner-marquee__track flex h-full w-max">
              {marqueeImages.map((image, index) =>
                renderMarqueeImage(image, index, "a")
              )}
              {marqueeImages.map((image, index) =>
                renderMarqueeImage(image, index, "b")
              )}
            </div>
          </div>
        </div>
      ) : imageUrl ? (
        <div className="relative w-full aspect-[4/3] overflow-hidden md:hidden">
          <img
            src={imageUrl}
            alt={titleLines.join(" ") || "Homepage banner"}
            className="h-full w-full object-cover"
          />
        </div>
      ) : (
        <div className="md:hidden">{renderFallbackBackground()}</div>
      )}

      {/* Desktop: full banner image */}
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={titleLines.join(" ") || "Homepage banner"}
          className="hidden md:block w-full h-auto"
        />
      ) : (
        <div className="hidden md:block">{renderFallbackBackground()}</div>
      )}

      {/* Content overlay */}
      <div className="absolute inset-0 flex items-end justify-start px-4 pb-4 sm:px-8 sm:pb-8 md:px-16 md:pb-10 lg:px-24 lg:pb-12 pointer-events-none">
        <div className="hero-banner-title-wrap text-left rounded-lg bg-black/25 px-4 py-3 sm:px-5 sm:py-4 md:px-6 md:py-5 max-w-sm sm:max-w-lg md:max-w-2xl lg:max-w-4xl pointer-events-auto">
          <h1 className="font-bold italic leading-[1.2] text-white drop-shadow-sm">
            {titleLines.map((line, index) => (
              <span
                key={`${line}-${index}`}
                className={
                  index === 0
                    ? "block text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
                    : "block mt-2 sm:mt-3 text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl"
                }
              >
                {line}
              </span>
            ))}
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
